/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { SetMyPayoutWalletResponse, SetMyPayoutWalletVars } from '../openapi-types.gen.js';

export type { SetMyPayoutWalletResponse, SetMyPayoutWalletVars } from '../openapi-types.gen.js';

export const useSetMyPayoutWallet = createMutationHook<SetMyPayoutWalletVars, SetMyPayoutWalletResponse, unknown>({
  specName: 'useSetMyPayoutWallet',
  path: '/v1/users/me/payout-wallet',
  method: 'PUT',
  resolveUrl: (vars: SetMyPayoutWalletVars) => `/v1/users/me/payout-wallet`,
  buildBody: (vars: SetMyPayoutWalletVars) => ({ address: vars.address }),
  parseResponse: (raw: unknown): SetMyPayoutWalletResponse => raw as SetMyPayoutWalletResponse,
  optimistic: [{
    queryKey: ['users', 'detail'],
    apply: (prev: any, vars: SetMyPayoutWalletVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      return next;
    },
  }],
  
  
});
